import { observer } from 'mobx-react-lite';
import React from 'react';

import { Icon, IconBus } from '@flixbus/honeycomb-icons-react';
import { Box, Tag, Tooltip } from '@flixbus/honeycomb-react';

import GridSticky from 'common/GridSticky';

import { VEHICLE_ASSIGNED_TEXT, buildTooltipId } from './texts';

import styles from './styles.module.css';

/**
 * @typedef {object} VehicleAssignmentShape
 * @property {string | null} mobilityPartnerName
 * @property {string | null} busNumber
 * @property {string} fromStationId
 * @property {string} toStationId
 */

/**
 * @typedef {object} VehicleAssignedProps
 * @property {VehicleAssignmentShape} vehicleAssignment
 */

/** @param {VehicleAssignedProps} props */
const VehicleAssigned = observer(({ vehicleAssignment }) => {
	const { mobilityPartnerName, busNumber, fromStationId, toStationId } = vehicleAssignment;

	return (
		<GridSticky>
			<Box extraClasses={styles.plate}>
				<Tooltip
					id={buildTooltipId(fromStationId, toStationId)}
					content={
						mobilityPartnerName !== null ? mobilityPartnerName : VEHICLE_ASSIGNED_TEXT.missingValue
					}
					openOnHover
					position="top"
				>
					<Tag display="outlined" small>
						<Icon InlineIcon={IconBus} />
						{busNumber ?? VEHICLE_ASSIGNED_TEXT.missingValue}
					</Tag>
				</Tooltip>
			</Box>
		</GridSticky>
	);
});

export default VehicleAssigned;
